export default __webpack_public_path__ + "static/media/pactofmalacodor.e432ec33.png";